<template>
    <div class="modal-wrapper" @click="close">
		<div class="modal-container" :class="view == 'form' ? 'modal-container-mini' : 'modal-container-full'" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12 col-lg-12">
						EDITAR STATUS DAS ENTREGAS DA CARGA
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body" :class="view == 'form' ? 'modal-body-mini' : 'modal-body-full'">
                <div v-if="loading" class="row">
                    <div class="col-xs-12 col-lg-12">
                        <div class="loading" :class="view == 'form' ? 'loading-mini' : 'loading-full'">
                            <span v-if="view == 'form'" class="loading-icon"><i class="fa fa-circle-notch fa-spin"></i></span>
                            <span v-else class="loading-percent"><b>{{ percent }}%</b></span>
                            <span class="loading-text">{{ loading_text }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="view == 'form'" class="row">
                    <div class="col-xs-12 col-lg-12">
                        <FormSelect v-model="form.cargo_selected" label="Carga" :options="cargo" icon="fa-boxes" :required="true" tooltip="Informe a carga que deseja editar os status de suas entregas" ref="cargo_selected" />
                    </div>
                </div>
                <div v-else-if="view == 'selection'" class="row">
                    <div class="col-xs">
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-12 col-lg-offset-2 col-lg-4 list-search">
                                    <FormInput v-model="form.search" label="Busque na entrega" type="text" icon="fa-search" tooltip="Informe uma palavra-chave para filtragem dos registros" ref="search" />
                                </div>
                                <div class="col-xs-12 col-lg-4 list-search">
                                    <FormSelect v-model="form.filter" label="Exibir entregas" :options="form.options" icon="fa-sort" @blur="searchedList()" tooltip="Selecione a exbição do status dos registros" ref="filter" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-12 col-lg-6 start-xs list-name"><h4>Entregas</h4></div>
                                <div class="col-xs-12 col-lg-6 end-xs list-total text-right"><h4>Selecionados: {{ selected.length }} de {{ list.length }}</h4></div>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="row list-head">
                                <div class="col-xs-1 list-head-item pointer" @click="onSelectAll()"><i class="fa-fw" :class="selected.length == list.length ? 'fas fa-check-square' : 'far fa-square'"></i></div>
                                <div class="col-xs-1 list-head-item">Sequência</div>
                                <div class="col-xs-2 list-head-item">Status</div>
                                <div class="col-xs-1 list-head-item">Número</div>
                                <div class="col-xs-1 list-head-item">Data entrega</div>
                                <div class="col-xs-2 list-head-item">Cliente</div>
                                <div class="col-xs-2 list-head-item">Endereço</div>
                                <div class="col-xs-1 list-head-item">Veículo</div>
                                <div class="col-xs-1 list-head-item">Peso</div>
                            </div>
                        </div>
                        <div v-if="searchedList().length > 0" class="col-xs-12 list list-body">
                            <div v-for="(register, index) in searchedList()" :key="'register-' + index" class="row list-body-item">
                                <div class="col-xs-1 list-body-item-text pointer" @click="onSelect(register)"><i class="fa-fw" :class="selected.includes(register) ? 'fas fa-check-square' : 'far fa-square'"></i></div>
                                <div class="col-xs-1 list-body-item-text">{{ register.sequence }}</div>
                                <div v-html="getStatus(register)" class="col-xs-2 list-body-item-text"></div>
                                <div class="col-xs-1 list-body-item-text">{{ register.document_number }}</div>
                                <div class="col-xs-1 list-body-item-text">{{ getFormatedTodayDate(register.date) }}</div>
                                <div class="col-xs-2 list-body-item-text capitalized">{{ register.customer_name.toLowerCase() }}</div>
                                <div class="col-xs-2 list-body-item-text capitalized">{{ (register.street.toLowerCase() + " - nº " + register.number + ", " + register.neighborhood.toLowerCase() + ", " + register.city.toLowerCase() + " - " + register.uf + ", " + register.postal_code) }}</div>
                                <div class="col-xs-1 list-body-item-text">{{ register.license_plate }}</div>
                                <div class="col-xs-1 list-body-item-text">{{ getWeight(register.weight) }}</div>
                                <div v-if="register.fk_delivery_observation" class="col-xs-2 col-lg-12 list-body-item-text"><p class="description-item"><b><i class="fa fa-fw fa-info-circle"></i> Observação:</b> {{ register.observation }}</p></div>
                            </div>
                        </div>
                        <div v-else class="col-xs-12 text-center">
                            <small><i>Não foram encontrados registros de entregas.</i></small>
                        </div>
                    </div>
                </div>
			</div>
			<div class="modal-footer">
                <div v-if="view == 'form'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> CANCELAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="getDeliveries()">
                            BUSCAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-search'"></i>
                        </button>
                    </div>
                </div>
				<div v-else-if="view == 'selection'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> CANCELAR
                        </button>
                        <button class="modal-button-back" @click="back" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-angle-left'"></i> VOLTAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="save()">
                            FINALIZAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-save'"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

import FormSelect from "@/components/FormSelect";
import FormInput from "@/components/FormInput";

export default {
	name: "DeliveryCargoStatus",

	props: {
        cargo: {
            type: Object,
            require: true,
        }
    },

	components: {
        FormSelect,
        FormInput,
    },

	data: function() {
		return {
			loading: false,
            loading_text: "",

            view: "form",
            form: {
                type: false,
                cargo_selected: "",
                search: "",
                options: {
                    "waiting": "Aguardando",
                    "in_progress": "Em andamento",
                    "check_in": "Check-in",
                    "finished": "Finalizado",
                    "failed": "Não entregue",
                }
            },

            list: [],
            selected: [],

            count: 0,
            percent: 0,
		}
	},

	methods: {
        /**
         * Busca com os dados da Web API Atak
         */
        getDeliveries: async function() {
            // Verifica se tem carga selecionada
            if (this.form.cargo_selected == "") {
                this.$notification.error("A carga deve ser selecionada.");
                this.$refs.cargo_selected.validate();
                return false;
            } else {
                // Inicia a requisição
                this.loading = true;
                
                // Inicia a lista
                this.list = [];
                this.selected = [];

                // Define o resultado
                let result = false;
                this.loading_text = "Buscando entregas...";
                // Faz o request
                try {
                    result = await Api.post("delivery/get-deliveries-cargo", { cargo: this.form.cargo_selected });
                } catch (ex) {
                    console.log(ex);
                    this.$notification.error("Não foi possível obter as entregas.");
                    this.loading = false;
                    this.loading_text = "";
                    return false;
                }
                
                // Verifica se houve error
                if (result.error) {
                    this.$notification.error(result.data);
                    this.loading = false;
                    this.loading_text = "";
                    return false;
                } else {
                    // Verifica se houve
                    if(result) {
                        if(result.error) {
                            if (result.data == "unauthorized") {
                                // Notifica o fim da sessão
                                this.$notification.error("Desculpe, sua sessão expirou.");
                                setTimeout(() => { 
                                    Api.logout();
                                    return;
                                }, 2000);
                            } else {
                                // Notifica o erro
                                this.$notification.error(result.data);

                                // Finaliza a requisição
                                this.loading = false;
                                this.loading_text = "";
                            }
                        } else {
                            // Verifica o resultado
                            if(result.total > 0) {
                                // Define o texto de feedback atual
                                this.count = 0;
                                this.percent = 0;

                                // Define a lista
                                this.list = result.data;

                                // Exibe a lista de seleção
                                this.view = "selection";
                                
                                // Percorre a lista buscando o restante das informações
                                for (let register of this.list) {
                                    // Verifica se já está finalizada
                                    if (register.status != "finished") {
                                        this.selected.push(register);
                                    }

                                    this.count++;
                                    this.calcPercent(this.count, this.list.length);

                                    if (this.count == result.total) {
                                        // Finaliza a sincronização
                                        this.loading = false;
                                        this.loading_text = "";
                                    }
                                }
                            } else {
                                // Retorna o modal ao formulário
                                this.view = "form";
                                this.$notification.error("Não foram encontrados registros de entregas para esta carga.");

                                // Finaliza a busca
                                this.loading = false;
                                this.loading_text = "";
                            }
                        }
                    } else {
                        // Retorna o modal ao formulário
                        this.view = "form";
                        this.$notification.error("Não foi possível sincronizar os pedidos.");
                        
                        // Finaliza a requisição
                        this.loading = false;
                        this.loading_text = "";
                    }
                }
                return true;
            }
		},

        /**
         * Busca com os dados da Web API Atak
         */
        save: async function() {
            // Verifica  quantidade de selecionados
            if (this.selected.length > 0) {
                // Verifica se topos os selecionados estão pronto para a atualização
                let confirm = await this.$alert.confirm("As entregas selecionadas da carga " + this.form.cargo_selected + " serão finalizadas manualmente. Deseja continuar?", "AVISO");
                if(!confirm) {
                    return;
                }
                
                // Confirma a verificação
                if (confirm) {
                    // Inicia a requisição
                    this.loading = true;
                    this.loading_text = "Atualizando as entregas...";
                    let registers = [];

                    // Solicita para cada registro
                    for (let register of this.selected) {
                        if ((register != "finished") && (register != "failed")) registers.push(register.id);
                    }

                    // Inicia a variável de retorno
                    let result = false;
                    try {
                        result = await Api.post("delivery/update-deliveries-status", { deliveries: registers});
                    } catch (ex) {
                        console.log(ex);
                        this.$notification.error("Não foi possível atualizar os status.");
                        this.loading = false;
                        this.loading_text = "";
                        return;
                    }

                    this.loading = false;
                    this.loading_text = "";

                    // Verifica se houve erro
                    if(result.error) {
                        if (result.data == "unauthorized") {
                            // Notifica o fim da sessão
                            this.$notification.error("Desculpe, sua sessão expirou.");
                            setTimeout(() => { 
                                Api.logout();
                                return;
                            }, 2000);
                        } else {
                            // Notifica o erro
                            this.$notification.error(result.data);
                        }
                    } else {
                        // Notifica o sucesso
                        this.$notification.success(result.data);
                        this.close();
                    }
                    return;
                } else {
                    this.$notification.error("É necessário confirmar para finalizar as entregas.");
                    return;
                }
            } else {
                this.$notification.error("Selecione ao menos um registro.");
                return;
            }
        },
        
        // Filtra com a lista
        searchedList: function() {
            if(this.form.search) {
                let exp = new RegExp(this.form.search.trim(), 'i');
                let searched_list = this.list.filter(register => 
                    exp.test(register.id) || 
                    exp.test(register.document_number) || 
                    exp.test(this.getFormatedTodayDate(register.date)) || 
                    exp.test(register.weight) || 
                    exp.test(register.customer_document) || 
                    exp.test(register.customer_name) || 
                    exp.test(register.postal_code) || 
                    exp.test(register.street) || 
                    exp.test(register.number) || 
                    exp.test(register.neighborhood) || 
                    exp.test(register.city) || 
                    exp.test(register.uf)
                );
                if (this.form.filter) {
                    return this.filtredList(searched_list);
                } else {
                    return searched_list;
                }
            } else {
               if (this.form.filter) {
                    return this.filtredList(this.list);
                } else {
                    return this.list;
                }
            }
        },

        // Filtra a lista
        filtredList: function(searched_list) {
            if (this.form.filter == "all") {
                return searched_list;
            } else if (this.form.filter == "waiting") {
                return searched_list.filter(register => register.status == "waiting" ? true : false);
            } else if (this.form.filter == "in_progress") {
                return searched_list.filter(register => (register.status == "in_progress" && register.checkin_date == null && register.checkin_location == null) ? true : false);
            } else if (this.form.filter == "check_in") {
                return searched_list.filter(register => (register.status == "in_progress" && register.checkin_date != null && register.checkin_location != null) ? true : false);
            } else if (this.form.filter == "finished") {
                return searched_list.filter(register => register.status == "finished" ? true : false);
            } else if (this.form.filter == "failed") {
                return searched_list.filter(register => register.status == "failed" ? true : false);
            } else {
                return searched_list;
            }
        },

        // Seleciona os registros que serão atualizados
        onSelectAll: function() {
            if (this.selected.length > 0) {
                this.selected = [];
            } else {
                this.list.map((register) => {
                    if (((register.status != "finished") && (register.status != "failed")) && !this.selected.includes(register)) {
                        this.selected.push(register);
                    }
                });
            }
        },

        // Seleciona os registros que serão atualizados
        onSelect: function(register) {
            if (this.selected.includes(register)) {
                let index = this.selected.indexOf(register);
                if(index !== false) {
                    this.selected.splice(index, 1);
                }
            } else {
                if (((register.status != "finished") && (register.status != "failed")) && !this.selected.includes(register)) {
                    this.selected.push(register);
                }
            }
        },

        // Voltar o modal
		back: function() {
			this.view = 'form';
            this.list = [];
            this.selected = [];
		},

        // Formata o status
        getStatus: function(register) {
            let status_formatted = "";
            switch (register.status) {
                case "waiting":
                    status_formatted = '<span><span style="color: #555;"><i class="fas fa-fw fa-circle"></i></span> Aguardando</span>';
                    break;
                case "in_progress":
                    if (register.checkin_date == null && register.checkin_location == null) status_formatted = '<span><span class="in_progess-color" style="color: #005ef7;"><i class="fas fa-fw fa-circle"></i></span> A caminho</span>';
                    else status_formatted = '<span><span style="color: #ffb300;"><i class="fas fa-fw fa-circle"></i></span> Entregando</span>';
                    break;
                case "finished":
                    status_formatted = '<span><span class="finished-color" style="color: #008000;"><i class="fas fa-fw fa-circle"></i></span> Finalizado</span>';
                    break;
                case "failed":
                    status_formatted = '<span><span class="failed-color" style="color: #ff0000;"><i class="fas fa-fw fa-circle"></i></span> Não entregue</span>';
                    break;
                default:
                    status_formatted = '<span><span class="waiting-color" style="color: #555;"><i class="fas fa-fw fa-circle"></i></span> Aguardando</span>';
                    break;
            }
            return status_formatted;
        },

        // Formata a data de entrega
        getFormatedTodayDate: function(date) {
            let formated = date.split("-").reverse().join("/");
            return formated;
        },

        // Formata a data de entrega
        getTodayDate: function() {
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0');
            let yyyy = today.getFullYear();
            
            return yyyy + '-' + mm + '-' + dd;
        },
        
        // Formata data de entrega
        getFormatedDate: function(date) {
            let aux = date.split("T")[0];
            let formated = aux.split("-");
            formated = formated.reverse().join("/");
            
            return formated;
        },
        
        // Formata o endereço
        formatedAddress: function(address, number, neighborhood, city, uf, postal_code) {
            let formated_address = "";

            if(address) {
                formated_address += address.toLowerCase();
            }
            
            if(number) {
                formated_address += ", " + number.toLowerCase();
            }
            
            if(neighborhood) {
                formated_address += " - " + neighborhood.toLowerCase();
            }
            
            if(city) {
                formated_address += ", " + city.toLowerCase();
            }
            
            if(uf) {
                formated_address += " - " + uf.toUpperCase();
            }
            
            if(postal_code) {
                formated_address += ", " + postal_code;
            }

            return formated_address;
        },
        
        // Formata o texto passado
        formatedText: function(text) {
            let formated_text = "";

            formated_text = text.toLowerCase();
            
            return formated_text;
        },

        getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },

        calcPercent: function(current, total) {
            this.percent = parseInt((current * 100) / total);
        },

        // Fecha o modal
		close: function() {
            if (!this.loading) {
                this.$emit("close");
            }
		},
	}
}
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-container-mini {
	width: 600px;
	height: 350px;
}

.modal-container-full {
	width: calc(100vw - 30px);
	height: calc(100vh - 30px);
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	min-height: 50px;
	padding: 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	padding: 15px;
	width: 100%;
	overflow-y: auto;
}

.modal-body-mini {
	height: 240px;
}

.modal-body-full {
    height: calc(100vh - 140px);
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: 61px;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

.btn-sync {
	width: 100%;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}
.btn-sync:disabled {
    background: #a0a0a0;
}

/*.btn-margin-top {
    margin-top: 30px;
}*/

.sync-list {
	position: relative;
	height: 100%;
	overflow: hidden;
}

.sync-list-container {
	float: left;
	width: 100%;
	height: 100%;
	overflow: auto;
	padding-bottom: 15px;
}

.sync-list-item {
	width: 100%;
	float: left;
	background: #eee;
	margin-bottom: 15px;
	padding: 10px;
}

.sync-list-synchronized-name {
	float: left;
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
	font-weight: bold;
}

.sync-list-uploading-status {
	float: left;
	width: 20%;
	font-size: 14px;
	text-align: right;
	color: #999;
}

.sync-list-result-collapse { 
	margin-top: 5px;
	margin-bottom: 5px;
}

.sync-list-result-collapse-header {
	width: 100%;
	padding-top: 5px;
	padding-bottom: 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
}

.sync-list-result-collapse-body {
	width: 100%;
	padding-left: 10px;
	white-space: nowrap;
	font-size: 11px;
}

.capitalized {
	text-transform: capitalize;
}

.pointer {
    cursor: pointer;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.list {
    margin-bottom: 30px;
}

.list-name, 
.list-search, 
.list-total {
    display: grid;
    align-content: center;
}

.list-name, 
.list-total {
    border-bottom: 1px solid #ccc;
}

.list-name > h4, 
.list-total > h4 {
    margin-top: 0px;
    margin-bottom: 5px;
}

.list-total > h4 {
    font-size: 1;
    font-weight: 400;
}

.list-head-item {
    /*font-size: 14px;*/
    font-weight: 600;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    background-color: #eee;
}

.list-body-item {
    /*font-size: 14px;*/
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #ccc;
	border-radius: 3px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
    margin-top: 5px;
}

.list-body-item:hover {
    background-color: #f0f0f0;
}

.list-body-item-cell {
    display: grid;
    align-content: center;
}

.list-body-item-text {
    display: grid;
	align-content: center;
}

.list-body-item-text.resume {
    font-size: 13px;
}

.modal-button-close {
	background: #222;
	border: 2px solid #222;
	color: #fff;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
    margin-right: 15px;
}

.modal-button-back {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-research {
	float: right;
    margin-right: 15px;
	background: #fff;
	border: 2px solid #222 !important;
    color: #222;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save:disabled,
.modal-button-research:disabled,
.modal-button-back:disabled,
.modal-button-close:disabled {
	cursor: not-allowed;
	opacity: 0.4;
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: rgba(255,255,255,.7);
    color: #222;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-mini {
    width: 600px;
    height: 239px;
    line-height: 239px;
}

.loading-full {
    width: calc(100vw - 30px);
	height: calc(100vh - 141px);
    line-height: calc(100vh - 141px);
}

.loading-icon, 
.loading-percent {
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 5px 20px 20px;
    font-size: 20px;
    z-index: 10;
}

.loading-text {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 20px 20px 5px;
    font-size: 20px;
    z-index: 10;
}

.error {
    color: red;
}

.success {
    color: green;
}

.gray {
    color: #ddd;
}

.map {
    height: calc(100vh - 170px) !important;
}

.card-map {
	position: absolute;
}

.card {
    height: auto !important;
    width: 370px;
	margin-top: 10px;
	margin-left: 5px;
    background: #fff;
    z-index: 3;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
}

.card-head {
    padding: 10px;
    background-color: #a6a6a6;
	color: rgb(44, 62, 80);
    font-size: 16px;
}

.card-body {
	height: auto !important;
    max-height: calc(100vh - 230px);
    padding: 10px 10px 0px 10px !important;
    background-color: #fff;
	overflow-y: auto;
}

.address-info-body-inner {
	float: left;
	width: 100%;
	border: 1px solid #f5f5f5;
	padding: 0 5px;
    margin-bottom: 10px;
}

.address-info-item {
	position: relative;
    padding: 10px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.address-info-item-left {
    display: grid;
    align-content: center;
    padding-right: 0px !important;
}

.address-info-item-right {
    display: grid;
    align-content: center;
    padding-left: 0px !important;
    font-size: 13px;
}

.card-body-customer {
    float: left;
    width: 100%;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
    /*padding: 10px;*/
}

.card-body-customer-item {
	position: relative;
    padding: 10px 15px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.card-body-customer-left {
    width: 50%;
    float: left;
    font-size: 12px;
    font-weight: bold;
	display: grid;
    align-content: center;
}

.card-body-customer-right {
    width: 50%;
    float: right;
    text-align: right;
    font-size: 12px;
}

.card-body-address {
    font-size: 14px;
    font-weight: bold;
}

.text-empty {
    /*font-style: italic;*/
    color: #aaa;
}

p.description-item {
	margin-block-start: 10px;
	margin-block-end: 0px;
	padding: 5px;
	background-color: #ccc;
	border-radius: 4px;
	font-size: 12px;
}
</style>